isInHideWatched